import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ModifiedFirstPartiesActions } from "../actions";
import { PayeeNamesService } from "../services/payee-names.service";
import { FirstParties } from "../models/FirstParties";
import { catchError, map, of, switchMap } from "rxjs";
import { ServiceError } from "../../create-request/models/shared/ServiceError";

@Injectable()
export class ModifiedFirstPartiesEffects {
  constructor(
    private actions$: Actions,
    private payeeNamesServicve: PayeeNamesService
  ) { }

  callGetModifiedFirstParties$ = createEffect(() => 
  this.actions$.pipe(
    ofType(ModifiedFirstPartiesActions.getModifiedFirstParties),
    switchMap((action) => {
      return this.payeeNamesServicve.getPayeeNames(action.subaccount, action.transactionType).pipe(
        map((response: FirstParties) => {
          return ModifiedFirstPartiesActions.getModifiedFirstPartiesSuccess({response});
        }),
        catchError((err: ServiceError) => of(ModifiedFirstPartiesActions.getModifiedFirstPartiesFailure(err)))
      );
    })
  ));
}